// import React, { useState } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import "swiper/css/autoplay";

// const OwerClientSlider = () => {
//   const [backgroundImage, setBackgroundImage] = useState(
//     "/CompanyImages/iinfra_back.webp"
//   );
//   const [activeIndex, setActiveIndex] = useState(0);

//   // Use placeholder images instead of actual imports
//   const companies = [
//     "/CompanyImages/mehartech.png",
//     "/CompanyImages/iinfra icon.png",
//     "/CompanyImages/gju.png",
//     "/CompanyImages/iinsaf blood logo.png",
//   ];

//   const backgrounds = [
//     "/CompanyImages/iifra_back.webp",
//     "/CompanyImages/meharetech_back.webp",
//     "/CompanyImages/gju_back.webp",
//     "/CompanyImages/blood banner.jpg",
//   ];

//   const testimonials = [
//     {
//       name: "John Doe",
//       profession: "Software Engineer",
//       rating: 5,
//       text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mollitia fugit nihil, aperiam maxime minima consequuntur!",
//       image: "https://randomuser.me/api/portraits/men/1.jpg",
//       background: backgrounds[0],
//       company: "Tech Solutions Inc.",
//     },
//     {
//       name: "Jane Smith",
//       profession: "Product Manager",
//       rating: 5,
//       text: "Exceptional service and outstanding results. Would highly recommend!",
//       image: "https://randomuser.me/api/portraits/women/1.jpg",
//       background: backgrounds[1],
//       company: "Innovation Labs",
//     },
//     {
//       name: "Mike Johnson",
//       profession: "CEO",
//       rating: 5,
//       text: "The team delivered beyond our expectations. Very professional and efficient.",
//       image: "https://randomuser.me/api/portraits/men/2.jpg",
//       background: backgrounds[2],
//       company: "Global Systems",
//     },
//     {
//       name: "Sarah Williams",
//       profession: "Marketing Director",
//       rating: 5,
//       text: "Great experience working with the team. They understand client needs perfectly.",
//       image: "https://randomuser.me/api/portraits/women/2.jpg",
//       background: backgrounds[3],
//       company: "Digital Marketing Pro",
//     },
//   ];

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 800,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 6000,
//     arrows: true,
//     fade: true,
//     beforeChange: (current, next) => {
//       setBackgroundImage(testimonials[next].background);
//       setActiveIndex(next);
//     },
//     dotsClass: "slick-dots custom-dots !bottom-[-3rem]", // Added bottom spacing
//     customPaging: (i) => (
//       <div
//         className={`w-3 h-3 rounded-full transition-all duration-500 ${
//           i === activeIndex
//             ? "bg-gradient-to-r from-blue-500 to-purple-500 w-10"
//             : "bg-gray-400/50"
//         }`}
//       />
//     ),
//   };

//   const renderPartners = () => (
//     <div className="flex flex-wrap items-center justify-center gap-12">
//       {companies.map((company, index) => (
//         <div key={index} className="group relative p-6">
//           {/* Added background container for logos */}
//           <div className="backdrop-blur-sm rounded-xl p-4 transition-all duration-300">
//             <div className="bg-white/10 rounded-3xl p-4 hover:bg-gradient-to-b hover:from-blue-800 hover:via-indigo-900 hover:to-purple-900 shadow-lg hover:shadow-[0_0_25px_10px_rgba(59,130,246,0.4)] transition-all duration-300">
//               <img
//                 className="h-24 w-auto relative z-10 transform transition-all duration-500 group-hover:scale-110"
//                 src={company}
//                 alt={`Partner ${index + 1}`}
//               />
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );

//   return (
//     <div className="relative">
//       {/* Testimonials Section */}
//       <div id="reviews" className="relative min-h-screen py-32">
//         {/* Background image with overlay */}
//         <div
//           className="absolute top-0 left-0 right-0 bottom-0 bg-cover bg-center transition-all duration-1000"
//           style={{
//             backgroundImage: `url('${backgroundImage}')`,
//           }}
//         >
//           {/* Added gray overlay */}
//           <div className="absolute inset-0 bg-gray-900/70 backdrop-blur-[2px]"></div>
//         </div>

//         <div className="container mx-auto px-4 relative z-10">
//           <div className="text-center mb-16">
//             <span className="bg-gradient-to-r from-blue-500 to-purple-500 text-transparent bg-clip-text text-sm font-bold tracking-wider uppercase">
//               Testimonials
//             </span>
//             <h2 className="text-4xl font-bold mt-4 bg-gradient-to-r from-blue-600 to-purple-500 bg-clip-text text-transparent">
//               What Our Clients Say
//             </h2>
//             <p className="text-xl text-white max-w-2xl mx-auto leading-relaxed">
//               Hear from our satisfied clients about their transformative
//               experiences
//             </p>
//           </div>

//           {/* Added padding bottom to create space for dots */}
//           <div className="pb-16">
//             {/* Testimonial Slider */}
//             <Slider {...settings}>
//               {testimonials.map((testimonial, index) => (
//                 <div key={index} className="focus:outline-none px-6">
//                   <div className="max-w-4xl mx-auto h-[500px]">
//                     {" "}
//                     {/* Added fixed height */}
//                     <div className="relative group h-full">
//                       {" "}
//                       {/* Added h-full */}
//                       {/* Enhanced testimonial card */}
//                       <div className="backdrop-blur-xl bg-gradient-to-br from-white/10 via-white/5 to-transparent p-12 rounded-3xl border border-white/10 shadow-2xl transform transition-all duration-500 hover:scale-[1.02] h-full flex flex-col justify-center">
//                         {" "}
//                         {/* Added h-full and flex properties */}
//                         {/* Profile image container */}
//                         <div className="relative mb-6 group flex justify-center">
//                           {/* Animated glow effect */}
//                           <div className="absolute inset-0 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-full blur-xl opacity-75 group-hover:opacity-100 transition-all duration-500 animate-pulse"></div>

//                           {/* Profile image */}
//                           <div className="relative">
//                             <div className="absolute inset-0 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-full animate-spin-slow"></div>
//                             <img
//                               src={testimonial.image}
//                               alt={testimonial.name}
//                               className="w-28 h-28 rounded-full border-4 border-white/30 object-cover relative z-10 transform transition-all duration-500 group-hover:scale-105 group-hover:border-white/50 p-1"
//                             />
//                           </div>
//                         </div>
//                         {/* Content container */}
//                         <div className="flex flex-col items-center justify-center flex-grow">
//                           {/* Author details with enhanced styling */}
//                           <div className="relative z-10 text-center space-y-3">
//                             <h4 className="text-3xl font-bold bg-gradient-to-r from-white via-blue-200 to-purple-200 bg-clip-text text-transparent mb-1 transform transition-all duration-300 hover:scale-105">
//                               {testimonial.name}
//                             </h4>

//                             <div className="space-y-2">
//                               <p className="text-blue-300 font-medium text-lg tracking-wide">
//                                 {testimonial.profession}
//                               </p>
//                               <p className="text-gray-400 font-medium">
//                                 {testimonial.company}
//                               </p>
//                             </div>

//                             {/* Testimonial text */}
//                             <p className="text-white/80 text-lg mt-4 max-w-2xl mx-auto">
//                               {testimonial.text}
//                             </p>

//                             {/* Rating stars */}
//                             <div className="flex items-center justify-center gap-2 mt-4">
//                               {[...Array(5)].map((_, i) => (
//                                 <span
//                                   key={i}
//                                   className={`text-2xl transform transition-all duration-300 hover:scale-125 cursor-pointer
//                                                                         ${
//                                                                           i <
//                                                                           testimonial.rating
//                                                                             ? "animate-pulse-subtle"
//                                                                             : ""
//                                                                         }
//                                                                         ${
//                                                                           i <
//                                                                           testimonial.rating
//                                                                             ? "text-yellow-400"
//                                                                             : "text-gray-600"
//                                                                         }`}
//                                 >
//                                   ★
//                                 </span>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </Slider>
//           </div>
//         </div>
//       </div>

//       {/* Partners Section with enhanced styling */}
//       <div className="relative py-20 bg-gradient-to-b from-black via-gray-900 to-black">
//         <div className="container mx-auto px-4">
//           <div className="text-center mb-16">
//             <span className="bg-gradient-to-r from-blue-500 to-purple-500 text-transparent bg-clip-text text-sm font-bold tracking-wider uppercase">
//               Trusted Partners
//             </span>
//             <h3 className="text-4xl font-bold mt-4 bg-gradient-to-r from-white to-gray-100 bg-clip-text text-transparent">
//               Companies That Trust Us
//             </h3>
//           </div>

//           {/* Desktop view */}
//           <div className="hidden md:block">{renderPartners()}</div>

//           {/* Mobile view with Swiper */}
//           <div className="block md:hidden">
//             <Swiper
//               modules={[Autoplay]}
//               spaceBetween={20}
//               slidesPerView={1}
//               loop={true}
//               speed={800}
//               autoplay={{
//                 delay: 3000,
//                 disableOnInteraction: false,
//               }}
//               className="w-full"
//             >
//               {companies.map((company, index) => (
//                 <SwiperSlide key={index}>
//                   <div className="group relative p-6">
//                     <div className="backdrop-blur-sm rounded-xl p-4 transition-all duration-300">
//                       <div className="bg-white/10 rounded-3xl p-4 hover:bg-gradient-to-b hover:from-blue-800 hover:via-indigo-900 hover:to-purple-900 shadow-lg hover:shadow-[0_0_25px_10px_rgba(59,130,246,0.4)] transition-all duration-300">
//                         <img
//                           className="h-24 w-auto mx-auto relative z-10 transform transition-all duration-500 group-hover:scale-110"
//                           src={company}
//                           alt={`Partner ${index + 1}`}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         @keyframes spin-slow {
//           from {
//             transform: rotate(0deg);
//           }
//           to {
//             transform: rotate(360deg);
//           }
//         }

//         @keyframes pulse-subtle {
//           0%,
//           100% {
//             transform: scale(1);
//             opacity: 1;
//           }
//           50% {
//             transform: scale(1.05);
//             opacity: 0.9;
//           }
//         }

//         .animate-spin-slow {
//           animation: spin-slow 10s linear infinite;
//         }

//         .animate-pulse-subtle {
//           animation: pulse-subtle 2s infinite;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default OwerClientSlider;

import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faQuoteLeft,
  faStar,
  faUsers,
  faHandshake,
  faAward,
  faGlobe,
  faHeart,
  faCheckCircle
} from '@fortawesome/free-solid-svg-icons';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

const OwerClientSlider = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 30 },
    transition: { duration: 0.6 }
  };

  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const staggerItem = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 20 },
    transition: { duration: 0.5 }
  };

  const companies = [
    {
      logo: "/CompanyImages/mehartech.png",
      name: "MeharTech",
      description: "Technology Solutions"
    },
    {
      logo: "/CompanyImages/iinfra icon.png",
      name: "IInfra",
      description: "Infrastructure Services"
    },
    {
      logo: "/CompanyImages/gju.png",
      name: "GJU",
      description: "Educational Institution"
    },
    {
      logo: "/CompanyImages/iinsaf blood logo.png",
      name: "IINSAF Blood",
      description: "Healthcare Initiative"
    },
  ];

  const testimonials = [
    {
      name: "Avinash Kumar",
      role: "Co-Founder at TechCorp",
      company: "TechCorp Solutions",
      text: "IINSAF has revolutionized how we connect with our audience. The platform's transparency and reach have helped us build genuine relationships with reporters and advertisers.",
      image: "https://randomuser.me/api/portraits/men/1.jpg",
      rating: 5,
      verified: true
    },
    {
      name: "Bharat Kunal",
      role: "Marketing Manager at InnovateLab",
      company: "InnovateLab",
      text: "Working with IINSAF has been transformative. Their platform connects us with verified reporters and helps us reach the right audience effectively.",
      image: "https://randomuser.me/api/portraits/men/2.jpg",
      rating: 5,
      verified: true
    },
    {
      name: "Prabhakar D",
      role: "Founder & CEO at DigitalFirst",
      company: "DigitalFirst Media",
      text: "IINSAF provides an excellent platform for authentic journalism and effective advertising. The community-driven approach makes all the difference.",
      image: "https://randomuser.me/api/portraits/men/3.jpg",
      rating: 5,
      verified: true
    },
    {
      name: "Priya Sharma",
      role: "Content Director at NewsHub",
      company: "NewsHub India",
      text: "As a reporter, IINSAF has given me access to genuine opportunities and helped me build credibility in the journalism community.",
      image: "https://randomuser.me/api/portraits/women/1.jpg",
      rating: 5,
      verified: true
    },
    {
      name: "Rajesh Patel",
      role: "Business Owner at LocalBiz",
      company: "LocalBiz Network",
      text: "The advertising opportunities on IINSAF are unmatched. We've seen significant growth in our business through their targeted marketing solutions.",
      image: "https://randomuser.me/api/portraits/men/4.jpg",
      rating: 5,
      verified: true
    }
  ];

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-blue-50 pt-20 pb-8 px-2 sm:px-4">
      {/* Testimonials Section */}
      <section className="w-full max-w-7xl mx-auto mb-16">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: isVisible ? 1 : 0, scale: isVisible ? 1 : 0.95 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <div className="bg-white/80 backdrop-blur-lg rounded-3xl shadow-2xl border border-white/20 p-8 sm:p-12">
            <div className="inline-block bg-gradient-to-r from-blue-500 to-blue-600 text-white px-6 py-2 rounded-full text-sm font-semibold mb-4 shadow-lg">
              TESTIMONIALS
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold mb-6">
              What Our <span className="bg-gradient-to-r from-blue-500 to-blue-600 bg-clip-text text-transparent">Clients</span> Say
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-blue-600 mx-auto rounded-full mb-6"></div>
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Hear from our satisfied clients about their transformative experiences with IINSAF's platform
            </p>
          </div>
        </motion.div>

        {/* Testimonials Grid */}
        <motion.div
          variants={staggerContainer}
          initial="initial"
          animate="animate"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              variants={staggerItem}
              className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-white/20 p-6 sm:p-8 hover:shadow-2xl transition-all duration-300 group"
            >
              {/* Quote Icon */}
              <div className="flex justify-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <FontAwesomeIcon icon={faQuoteLeft} className="text-white text-lg" />
                </div>
              </div>

              {/* Rating Stars */}
              <div className="flex justify-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FontAwesomeIcon 
                    key={i} 
                    icon={faStar} 
                    className="text-yellow-400 text-sm" 
                  />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-600 text-center mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>

              {/* Profile Section */}
              <div className="text-center">
                <div className="relative inline-block mb-4">
                  <div className="w-16 h-16 rounded-full overflow-hidden border-4 border-white shadow-lg mx-auto">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  {testimonial.verified && (
                    <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                      <FontAwesomeIcon icon={faCheckCircle} className="text-white text-xs" />
                    </div>
                  )}
                </div>
                
                <h4 className="text-lg font-bold text-gray-800 mb-1">{testimonial.name}</h4>
                <p className="text-sm text-blue-600 font-medium mb-1">{testimonial.role}</p>
                <p className="text-xs text-gray-500">{testimonial.company}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </section>

      {/* Partners Section */}
      <section className="w-full max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 30 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="bg-white/80 backdrop-blur-lg rounded-3xl shadow-2xl border border-white/20 p-8 sm:p-12"
        >
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-2 rounded-full text-sm font-semibold mb-4 shadow-lg">
              TRUSTED PARTNERS
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-4">
              Companies That <span className="bg-gradient-to-r from-green-500 to-green-600 bg-clip-text text-transparent">Trust Us</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-green-500 to-green-600 mx-auto rounded-full mb-6"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We're proud to partner with leading organizations across various industries
            </p>
          </div>

          {/* Partners Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {companies.map((company, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group"
              >
                <div className="bg-white/50 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/80 transition-all duration-300 hover:shadow-lg border border-white/20 group-hover:border-green-200">
                  <div className="flex flex-col items-center text-center">
                    <div className="w-20 h-20 mb-4 flex items-center justify-center">
                      <img
                        src={company.logo}
                        alt={company.name}
                        className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                    <h3 className="text-sm font-semibold text-gray-800 mb-1">{company.name}</h3>
                    <p className="text-xs text-gray-500">{company.description}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Stats Section */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 30 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="mt-12 pt-8 border-t border-gray-200"
          >
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { number: "100+", label: "Partners", icon: faHandshake, color: "from-blue-500 to-blue-600" },
                { number: "50K+", label: "Users", icon: faUsers, color: "from-green-500 to-green-600" },
                { number: "99%", label: "Satisfaction", icon: faHeart, color: "from-red-500 to-red-600" },
                { number: "24/7", label: "Support", icon: faAward, color: "from-purple-500 to-purple-600" }
              ].map((stat, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="text-center"
                >
                  <div className={`w-16 h-16 bg-gradient-to-r ${stat.color} rounded-2xl flex items-center justify-center mx-auto mb-3 shadow-lg`}>
                    <FontAwesomeIcon icon={stat.icon} className="text-white text-xl" />
                  </div>
                  <div className="text-2xl sm:text-3xl font-bold text-gray-800 mb-1">{stat.number}</div>
                  <div className="text-sm text-gray-600">{stat.label}</div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </section>
    </div>
  );
};

export default OwerClientSlider;
